import React from 'react'
import { JsonLdScript } from '../JsonLdScript/JsonLdScript'
import { useStoreConfig } from '@config/hooks/useStoreConfig'

export const Organization = ({
    asPath
}: {
    asPath: string
}): JSX.Element | null => {
    const { seo } = useStoreConfig()
    if (
        !seo.organization ||
        asPath !== seo.organization.allowedPath ||
        !seo.organization.content
    ) {
        return null
    }
    const content = { ...seo.organization.content }

    // Add schema.org type names
    if (content['contactPoint']) {
        content['contactPoint'].map((item) => {
            return {
                '@type': 'ContactPoint',
                ...item
            }
        })
    }

    return <JsonLdScript id="organization-json-ld" data={content} />
}
